module.exports = __webpack_public_path__ + "static/media/4-a.93d2efe0.png";